module.exports = __webpack_public_path__ + "static/the-evolution-of-beauty-4aaf9420a4c6a4d95f67b47026ea87ea.jpg";